
export function no_es_vacio(txt) {
    return !(txt === null || String(txt).trim() === '');
}

export function es_vacio(txt) {
    return !no_es_vacio(txt);

}

export function es_hora(txt) {
    var patron = /^([01]?\d|2[0-3]):[0-5]\d$/;
    return patron.test(txt);

}

export function es_entero(txt) {
    var patron = /^\d+$/;
    return patron.test(txt);
}

export function es_decimal(txt) {
    var patron = /^-?\d*(\.\d+)?$/;
    return patron.test(txt);
}

// noinspection JSUnusedGlobalSymbols
export function solo_texto(txt) {
    var patron = /^[A-Za-z\s]+$/;
    return patron.test(txt);
}

// noinspection JSUnusedGlobalSymbols
export function valid_IP(txt) {
    // Se valida cada octeto por separado: 4 octetos (0-255) separados por '.'
    let octeto = /^(\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])$/;
    let octetos = String(txt).split('.');
    return octetos.length === 4 && octetos.every((o) => octeto.test(o));
}

export function isGreaterThan(a, b) {
    return Number.parseInt(a) > Number.parseInt(b);
}

export function isGreaterOrEqual(a, b) {
    return Number.parseInt(a) >= Number.parseInt(b);
}

